import styled from "styled-components";

const Wrapper = styled.p`
  font-size: 1em;
  font-weight: 400;
  line-height: 1.4em;
  text-align: left !important;
  color: ${(props) => props.theme.colors.black} !important;

  a {
    text-decoration: underline !important;
    text-decoration-color: ${(props) =>
      props.theme.colors.white}66; // lighter/more transparent underline
  }
`;

const NewsParagraph = (props: { children?: any }) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default NewsParagraph;
